import { useCallback } from 'react';


export const useWhatsapp = (message = '') => {
  return useCallback(() => {
    const encodedMessage = encodeURIComponent(message);
    const appUrl = `whatsapp://send?phone=${process.env.REACT_APP_PROFILE_TEL}&text=${encodedMessage}`;
    const webUrl = `https://wa.me/${process.env.REACT_APP_PROFILE_TEL}?text=${encodedMessage}`;

    // Try opening WhatsApp app
    window.location.href = appUrl;

    // Fallback to web after short delay
    setTimeout(() => {
      window.open(webUrl, '_blank');
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [process.env.REACT_APP_PROFILE_TEL, message]);
};
